import { BoxConfigRefType } from '@wolffun/shared/src/types';
export let BalanceType;

(function (BalanceType) {
  BalanceType[BalanceType["UPGRADE_HERO"] = 1] = "UPGRADE_HERO";
  BalanceType[BalanceType["BATTLE_END"] = 2] = "BATTLE_END";
  BalanceType[BalanceType["LEVEL_UP"] = 4] = "LEVEL_UP";
  BalanceType[BalanceType["RANKING_REWARD"] = 5] = "RANKING_REWARD";
  BalanceType[BalanceType["SEASON_BOX_REWARD"] = 6] = "SEASON_BOX_REWARD";
  BalanceType[BalanceType["SHOP_POWER_POINT"] = 8] = "SHOP_POWER_POINT";
  BalanceType[BalanceType["REFERRAL_REWARD"] = 10] = "REFERRAL_REWARD";
  BalanceType[BalanceType["SHOP_BOX_NON_NFT"] = 11] = "SHOP_BOX_NON_NFT";
  BalanceType[BalanceType["SPECIAL_EVENT_FEE_JOIN"] = 13] = "SPECIAL_EVENT_FEE_JOIN";
  BalanceType[BalanceType["BUY_SKILL_TURN"] = 14] = "BUY_SKILL_TURN";
  BalanceType[BalanceType["PLAY_AGAIN_BONUS"] = 16] = "PLAY_AGAIN_BONUS";
  BalanceType[BalanceType["FUSION_REFRESH_OUTPUT"] = 19] = "FUSION_REFRESH_OUTPUT";
  BalanceType[BalanceType["CHANGE_NAME_PROFILE"] = 21] = "CHANGE_NAME_PROFILE";
  BalanceType[BalanceType["TRADING_EVENT_DAILY"] = 24] = "TRADING_EVENT_DAILY";
  BalanceType[BalanceType["TRADING_REFRESH_DAILY"] = 25] = "TRADING_REFRESH_DAILY";
  BalanceType[BalanceType["DEPOSIT"] = 50] = "DEPOSIT";
  BalanceType[BalanceType["CLAIM"] = 51] = "CLAIM";
  BalanceType[BalanceType["CLAIM_FEE"] = 52] = "CLAIM_FEE";
  BalanceType[BalanceType["VESTING_CLAIM"] = 53] = "VESTING_CLAIM";
  BalanceType[BalanceType["CONVERT_VESTING"] = 54] = "CONVERT_VESTING";
  BalanceType[BalanceType["CREATOR_PROGRAM_VIEWER"] = 55] = "CREATOR_PROGRAM_VIEWER";
  BalanceType[BalanceType["STAKING_REWARD"] = 60] = "STAKING_REWARD";
  BalanceType[BalanceType["OPEN_GIFT_BOX"] = 62] = "OPEN_GIFT_BOX";
  BalanceType[BalanceType["BUY_PRIVATE_SALE"] = 70] = "BUY_PRIVATE_SALE";
  BalanceType[BalanceType["REFUND_PRIVATE_SALE"] = 71] = "REFUND_PRIVATE_SALE";
  BalanceType[BalanceType["CLAIM_REFUND"] = 105] = "CLAIM_REFUND";
  BalanceType[BalanceType["REFERRAL_REWARD_MKP"] = 20] = "REFERRAL_REWARD_MKP";
  BalanceType[BalanceType["DAILY_QUEST"] = 61] = "DAILY_QUEST";
  BalanceType[BalanceType["MKP_QUEST_STAGE_REWARD"] = 63] = "MKP_QUEST_STAGE_REWARD";
  BalanceType[BalanceType["MKP_QUEST_DAILY_CHECKIN"] = 64] = "MKP_QUEST_DAILY_CHECKIN";
  BalanceType[BalanceType["MKP_QUEST_DAILY_STREAK"] = 65] = "MKP_QUEST_DAILY_STREAK";
  BalanceType[BalanceType["MKP_QUEST_LB_REWARD"] = 66] = "MKP_QUEST_LB_REWARD";
  BalanceType[BalanceType["MKP_QUEST_BOX_BUY"] = 67] = "MKP_QUEST_BOX_BUY";
  BalanceType[BalanceType["MKP_QUEST_BOX_OPEN"] = 68] = "MKP_QUEST_BOX_OPEN";
  BalanceType[BalanceType["MKP_QUEST_REFRESH"] = 69] = "MKP_QUEST_REFRESH";
  BalanceType[BalanceType["ADMIN_REVERT"] = 104] = "ADMIN_REVERT";
  BalanceType[BalanceType["WHEEL_REWARD"] = 107] = "WHEEL_REWARD";
  BalanceType[BalanceType["MYTHICAL_CHRISTMAS_BOX"] = 106] = "MYTHICAL_CHRISTMAS_BOX";
})(BalanceType || (BalanceType = {}));

export let TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus[TransactionStatus["NEW"] = 1] = "NEW";
  TransactionStatus[TransactionStatus["PENDING"] = 2] = "PENDING";
  TransactionStatus[TransactionStatus["SUCCESS"] = 3] = "SUCCESS";
  TransactionStatus[TransactionStatus["WAITING"] = 4] = "WAITING";
  TransactionStatus[TransactionStatus["ADMIN_REVERT"] = 10] = "ADMIN_REVERT";
  TransactionStatus[TransactionStatus["COMFIRM_SUCCESS"] = 20] = "COMFIRM_SUCCESS";
  TransactionStatus[TransactionStatus["COMFIRM_ERROR"] = 96] = "COMFIRM_ERROR";
  TransactionStatus[TransactionStatus["REJECTED"] = 97] = "REJECTED";
  TransactionStatus[TransactionStatus["ERROR"] = 98] = "ERROR";
  TransactionStatus[TransactionStatus["FAILED"] = 99] = "FAILED";
  TransactionStatus[TransactionStatus["REFUND_PENDING"] = 100] = "REFUND_PENDING";
  TransactionStatus[TransactionStatus["REFUND_SUCCESS"] = 101] = "REFUND_SUCCESS";
  TransactionStatus[TransactionStatus["REFUND_ERROR"] = 102] = "REFUND_ERROR";
})(TransactionStatus || (TransactionStatus = {}));

export let TransactionType;

(function (TransactionType) {
  TransactionType[TransactionType["DEPOSIT"] = 1] = "DEPOSIT";
  TransactionType[TransactionType["CLAIM"] = 2] = "CLAIM";
})(TransactionType || (TransactionType = {}));

export let CosmeticSource;

(function (CosmeticSource) {
  CosmeticSource[CosmeticSource["OPEN_BOX"] = 1] = "OPEN_BOX";
  CosmeticSource[CosmeticSource["SEASON_END"] = 2] = "SEASON_END";
  CosmeticSource[CosmeticSource["RANKING_REWARD"] = 3] = "RANKING_REWARD";
  CosmeticSource[CosmeticSource["SOLD"] = 4] = "SOLD";
  CosmeticSource[CosmeticSource["PURCHASE"] = 5] = "PURCHASE";
  CosmeticSource[CosmeticSource["MINT"] = 6] = "MINT";
  CosmeticSource[CosmeticSource["WHEEL_REWARD"] = 8] = "WHEEL_REWARD";
})(CosmeticSource || (CosmeticSource = {}));

export let HeroHistoryStatus;

(function (HeroHistoryStatus) {
  HeroHistoryStatus[HeroHistoryStatus["PROCESSING"] = 1] = "PROCESSING";
  HeroHistoryStatus[HeroHistoryStatus["SUCCESS"] = 2] = "SUCCESS";
  HeroHistoryStatus[HeroHistoryStatus["FAILED"] = 3] = "FAILED";
})(HeroHistoryStatus || (HeroHistoryStatus = {}));

export let HeroSource;

(function (HeroSource) {
  HeroSource[HeroSource["OPEN_BOX"] = 1] = "OPEN_BOX";
  HeroSource[HeroSource["LISTING"] = 2] = "LISTING";
  HeroSource[HeroSource["SOLD"] = 3] = "SOLD";
  HeroSource[HeroSource["PURCHASE"] = 4] = "PURCHASE";
  HeroSource[HeroSource["NON_NFT_SHOP"] = 5] = "NON_NFT_SHOP";
  HeroSource[HeroSource["MINT"] = 6] = "MINT";
  HeroSource[HeroSource["NEW_USER_REWARD"] = 7] = "NEW_USER_REWARD";
  HeroSource[HeroSource["FIRST_FEE"] = 8] = "FIRST_FEE";
  HeroSource[HeroSource["RANKING"] = 9] = "RANKING";
  HeroSource[HeroSource["UNLIST"] = 10] = "UNLIST";
  HeroSource[HeroSource["FUSION_PRODUCT"] = 11] = "FUSION_PRODUCT";
  HeroSource[HeroSource["WHEEL_REWARD"] = 12] = "WHEEL_REWARD";
})(HeroSource || (HeroSource = {}));

export let MarketPlaceTab;

(function (MarketPlaceTab) {
  MarketPlaceTab["HEROES"] = "heroes";
  MarketPlaceTab["COSMETICS"] = "cosmetics";
})(MarketPlaceTab || (MarketPlaceTab = {}));

export let MarketType;

(function (MarketType) {
  MarketType[MarketType["NOT_FOR_SALE"] = 0] = "NOT_FOR_SALE";
  MarketType[MarketType["SALE"] = 10] = "SALE";
  MarketType[MarketType["AUCTION"] = 20] = "AUCTION";
  MarketType[MarketType["FOR_RENT"] = 30] = "FOR_RENT";
  MarketType[MarketType["RENTED"] = 31] = "RENTED";
})(MarketType || (MarketType = {}));

export let SearchParamsSortOption;

(function (SearchParamsSortOption) {
  SearchParamsSortOption["ID_ASC"] = "IdAsc";
  SearchParamsSortOption["ID_DESC"] = "IdDesc";
  SearchParamsSortOption["PRICE_ASC"] = "PriceAsc";
  SearchParamsSortOption["PRICE_DESC"] = "PriceDesc";
  SearchParamsSortOption["LATEST"] = "Latest";
  SearchParamsSortOption["OLDEST"] = "Oldest";
  SearchParamsSortOption["PRICE_PER_BATTLES"] = "PPB";
  SearchParamsSortOption["HERO_RARITY"] = "hr";
  SearchParamsSortOption["GTHC_BATTLES"] = "gthcb";
  SearchParamsSortOption["TROPHY_CLASS"] = "tc";
  SearchParamsSortOption["LEVEL"] = "lv";
})(SearchParamsSortOption || (SearchParamsSortOption = {}));

export let VestingSafeType;

(function (VestingSafeType) {
  VestingSafeType[VestingSafeType["DEPOSIT"] = 0] = "DEPOSIT";
  VestingSafeType[VestingSafeType["CLAIM"] = 1] = "CLAIM";
})(VestingSafeType || (VestingSafeType = {}));

export let VestingSafeSource;

(function (VestingSafeSource) {
  VestingSafeSource[VestingSafeSource["VESTING_CLAIM"] = 53] = "VESTING_CLAIM";
  VestingSafeSource[VestingSafeSource["SPECIAL_EVENT_REWARD"] = 12] = "SPECIAL_EVENT_REWARD";
  VestingSafeSource[VestingSafeSource["FUSION_CASHBACK"] = 17] = "FUSION_CASHBACK";
  VestingSafeSource[VestingSafeSource["FUSION_LEADERBOARD"] = 18] = "FUSION_LEADERBOARD";
  VestingSafeSource[VestingSafeSource["TRADING_EVENT_CASHBACK"] = 22] = "TRADING_EVENT_CASHBACK";
  VestingSafeSource[VestingSafeSource["TRADING_EVENT_LEADERBOARD"] = 23] = "TRADING_EVENT_LEADERBOARD";
  VestingSafeSource[VestingSafeSource["ADMIN"] = 101] = "ADMIN";
  VestingSafeSource[VestingSafeSource["CREATOR_PROGRAM_CREATOR"] = 56] = "CREATOR_PROGRAM_CREATOR";
})(VestingSafeSource || (VestingSafeSource = {}));

export let IngameMode;

(function (IngameMode) {
  IngameMode[IngameMode["TEAM_COLLECT_STAR"] = 0] = "TEAM_COLLECT_STAR";
  IngameMode[IngameMode["SOLO_SURVIVAL"] = 1] = "SOLO_SURVIVAL";
  IngameMode[IngameMode["DUAL_SURVIVAL"] = 2] = "DUAL_SURVIVAL";
  IngameMode[IngameMode["TEAM_COLLECT_STAR_4_VS_4"] = 3] = "TEAM_COLLECT_STAR_4_VS_4";
  IngameMode[IngameMode["KING"] = 5] = "KING";
  IngameMode[IngameMode["DEATH_MATCH"] = 6] = "DEATH_MATCH";
  IngameMode[IngameMode["DEATH_MATCH_3_VS_3"] = 7] = "DEATH_MATCH_3_VS_3";
  IngameMode[IngameMode["FLAG"] = 8] = "FLAG";
  IngameMode[IngameMode["TOWER"] = 9] = "TOWER";
  IngameMode[IngameMode["TRY_HERO_SKILL_MODE"] = 99] = "TRY_HERO_SKILL_MODE";
  IngameMode[IngameMode["NONE"] = 100] = "NONE";
  IngameMode[IngameMode["TUTORIAL"] = 254] = "TUTORIAL";
})(IngameMode || (IngameMode = {}));

export let BattleResult;

(function (BattleResult) {
  BattleResult[BattleResult["LOSE"] = -1] = "LOSE";
  BattleResult[BattleResult["DRAW"] = 0] = "DRAW";
  BattleResult[BattleResult["VICTORY"] = 1] = "VICTORY";
})(BattleResult || (BattleResult = {}));

export let BoxSource;

(function (BoxSource) {
  BoxSource[BoxSource["PURCHASE"] = 1] = "PURCHASE";
  BoxSource[BoxSource["OPEN"] = 2] = "OPEN";
  BoxSource[BoxSource["ADMIN"] = 100] = "ADMIN";
  BoxSource[BoxSource["BINANCE_CLAIM"] = 101] = "BINANCE_CLAIM";
})(BoxSource || (BoxSource = {}));